export default __webpack_public_path__ + "static/cow-93337dfa0170c3b127548e331e0aef76.svg";